import { MessageGraphic } from 'src/shared/components/icons/message-graphic'
import { Button } from 'src/shared/components/ui/buttons/button'
import { Card, CardContent, CardHeader } from 'src/shared/components/ui/cards/card'

interface ErrorCardProps {
  title?: string
  description?: string
  buttonText?: string
  onRetry: () => void | Promise<void>
}

export const ErrorCard = ({
  title,
  description = 'You got disconnected from chat',
  buttonText = 'Refresh messages',
  onRetry,
}: ErrorCardProps) => {
  const handleRetry = async () => {
    try {
      await onRetry()
    } catch (error) {
      console.error('Retry failed:', error)
    }
  }

  return (
    <div className="flex min-h-[inherit] items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <div className="flex flex-col items-center gap-6 text-center text-primary">
            <div className="rounded-full bg-background/10 p-3">
              <MessageGraphic size={125} />
            </div>
            <div className="space-y-2">
              {title && <h3 className="text-3xl font-medium">{title}</h3>}
              {description && <p className="text-xl text-muted">{description}</p>}
            </div>
          </div>
        </CardHeader>
        <CardContent>
          <Button
            onClick={handleRetry}
            variant="default"
            className="w-full rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90"
          >
            {buttonText}
          </Button>
        </CardContent>
      </Card>
    </div>
  )
}
